module.exports = __webpack_public_path__ + "img/img6.fe88da80.png";